var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"contents_wrapper"},[_c('div',{staticClass:"contents"},[_c('p',{staticClass:"large_white_label"},[_vm._v("ようこそ"+_vm._s(_vm.user.displayName)+"さん")]),_c('MypageButtonBlock')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }